import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/share/services/auth.service';
import { ITourData, ITourDetail, ITourGroupDetail, TourManagementService } from './tour-management.service';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { IPageViewModel } from 'src/app/share/pages/pages';


@Component({
  selector: 'app-tour-management',
  templateUrl: './tour-management.component.html',
  styleUrls: ['./tour-management.component.scss']
})
export class TourManagementComponent implements OnInit {

  
  constructor(private authService: AuthService, private tourManagementService: TourManagementService, private router: Router) { }

  vm$: Observable<any>;
  startDate: Date;
  endDate: Date;
  bookingAgentCode: string;
  customerCode: string;
  passengerCode: string;
  eventCode: string;

  tmDatePickerOptions: IMyOptions = {
    todayBtnTxt: "Today",
    clearBtnTxt: "Clear",
    closeBtnTxt: "Close",
    showTodayBtn: true,
    showClearDateBtn: true,
    dateFormat: 'mm/dd/yyyy'
  };

  ngOnInit() {
    this.vm$ = this.loadTourManagementData$();
  } 

  private loadTourManagementData$(): Observable<ITourManagementViewData> {
    return this.tourManagementService.getMockDate().pipe(
      map((v: ITourData) => {
        const ret: ITourManagementViewData = {
          selectionDisallowed: true,
          tourGroupDetails: v.groupDetails,
          tourGroupDetailsFiltered: v.groupDetails
        };
        return ret;
      }
    ));
  }

  /**
   * 
   */
   refreshPage() {
    this.vm$ = this.loadTourManagementData$();
    this.authService.userInRole;
  }
  
  click(i: ITourDetail) {
    this.router.navigateByUrl('dashboards/tour-management-detail/' + (i == undefined ? '0' : i.tourId));
  }

  addNewTour() {
    this.click(undefined);
  }


}

/**
* 
*/
interface ITourManagementViewData extends IPageViewModel {
  selectionDisallowed: boolean;
  tourGroupDetails: ITourGroupDetail[];
  tourGroupDetailsFiltered: ITourGroupDetail[];
}